var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    color: _vm.colors.theme == 'dark' ? "#fff" : "#000",
    border: _vm.colors.theme == 'dark' ? "1px solid #fff" : "1px solid #000"
  }),attrs:{"id":"statement_header"}},[_c('h1',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }